(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hsk-holiday-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hsk-nhl-phone-video')) {
  customElements.define('hsk-nhl-phone-video', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const video = this.querySelector('video');
      const overlay = this.querySelector('.hsk-n5__play');
      const buttons = [...this.querySelectorAll('[data-play]')];
      if (!video || !overlay) return;
      this.initialized = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const label = overlay.querySelector('[data-play-label]');
      const watchLabel = this.querySelector('[data-watch-label]');
      this.breakpoint = matchMedia('(max-width: 989px)');
      const silence = () => { video.defaultMuted = true; if (!video.muted) video.muted = true; if (video.volume !== 0) video.volume = 0; };
      const ready = () => { for (const b of buttons) b.disabled = false; label.textContent = 'Watch video'; };
      this.setSource = () => {
        const mobile = this.breakpoint.matches;
        const mode = mobile ? 'mobile' : 'desktop';
        if (this.mode === mode) return;
        this.mode = mode;
        video.pause(); video.controls = false; silence();
        video.src = mobile ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        video.poster = mobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
        video.width = 1080; video.height = mobile ? 1350 : 1680;
        for (const b of buttons) b.hidden = false;
        ready(); watchLabel.textContent = 'Watch the video'; this.dataset.layout = mode;
      };
      for (const b of buttons) b.addEventListener('click', async event => {
        event.preventDefault();
        if (b !== overlay && !video.paused) { video.pause(); return; }
        if (b !== overlay) video.scrollIntoView({ behavior: 'instant', block: 'center' });
        silence(); video.controls = true;
        for (const button of buttons) button.disabled = true;
        label.textContent = 'Loading...';
        try { await video.play(); overlay.hidden = true; ready(); if (event.detail === 0) video.focus({ preventScroll: true }); }
        catch (_) { overlay.hidden = false; ready(); label.textContent = 'Tap to retry'; }
      }, options);
      video.addEventListener('playing', () => { overlay.hidden = true; ready(); watchLabel.textContent = 'Pause video'; }, options);
      video.addEventListener('pause', () => { watchLabel.textContent = 'Watch the video'; }, options);
      video.addEventListener('volumechange', silence, options);
      video.addEventListener('error', () => { overlay.hidden = false; ready(); label.textContent = 'Tap to retry'; }, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); }, options);
      this.breakpoint.addEventListener('change', this.setSource);
      this.setSource();
      if ('IntersectionObserver' in window) { this.observer = new IntersectionObserver(entries => { for (const entry of entries) if (!entry.isIntersecting) video.pause(); }, { threshold: 0.01 }); this.observer.observe(video); }
    }
    disconnectedCallback() { this.querySelector('video')?.pause(); this.observer?.disconnect(); this.abort?.abort(); this.breakpoint?.removeEventListener('change', this.setSource); this.initialized = false; this.mode = null; }
  });
}
  } catch(e) { console.error(e); }
})();

})();
